module.exports = __webpack_public_path__ + "static/media/analyzer-bc.1dba0d53.png";